import { onFind } from "@elements/init-modules-in-scope";
import { on } from "@elements/dom-utils";

export function init() {
    let lastClickedElement = null;

    onFind('.js-lightbox__item', function (element) {
        on('click', function () {
            lastClickedElement = element;
        }, element);

        on('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ')
                lastClickedElement = element;
        }, element);
    });

    onFind('.js-lightbox', function (baseElement) {
        baseElement.addEventListener('lgAfterClose', function () {
            if (lastClickedElement) {
                setTimeout(() => {
                    lastClickedElement.focus();
                    lastClickedElement = null;
                }, 100);
            }
        });
    });
}
